import React, { useEffect, useRef, useState } from "react";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import LocalizationSwitcher from "@components/localizationSwitcher/LocalizationSwitcher";
import { AdminNavRoutes, Roles, StudentsNavRoutes } from "@constants/index";
import { IddinkEmployeeRoutes, LogOutRoute, SchoolNavRoutes } from "@constants/NavRoutes";

import "./TopBar.scss";

import MenuItem from "../MenuItem/MenuItem";
import MenuItemMobile from "../MenuItemMobile/MenuItemMobile";

const widthMobile = 980;

export function TopBar({ changeLang }) {
    const navigate = useNavigate();
    const ref = useRef();
    // @ts-ignore
    const userData = useSelector((state) => state.user.credentials);
    const [navBarButtons, setNavBarButtons] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < widthMobile);
    const [menuOpen, setMenuOpen] = useState(false);
    const [openMenus, setOpenMenus] = useState({});
    const [windowDimenion, detectHW] = useState({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight,
    });

    const detectSize = () => {
        detectHW({
            winWidth: window.innerWidth,
            winHeight: window.innerHeight,
        });
    };

    useEffect(() => {
        setIsMobile(windowDimenion.winWidth < widthMobile);
    }, [windowDimenion]);

    useEffect(() => {
        window.addEventListener("resize", detectSize);
        setMenuItems();
        return () => {
            window.removeEventListener("resize", detectSize);
        };
    }, []);

    useEffect(() => {
        const handler = (event) => {
            const target = event.target;
            if (menuOpen && ref.current && !ref.current.contains(target)) {
                setMenuOpen(false);
            }
            if (openMenuIsOpen() && ref.current && !ref.current.contains(target)) {
                setOpenMenus({});
            }
        };

        document.addEventListener("mousedown", handler);
        document.addEventListener("touchstart", handler);

        return () => {
            document.removeEventListener("mousedown", handler);
            document.removeEventListener("touchstart", handler);
        };
    }, [menuOpen]);

    const setMenuItems = () => {
        if (userData !== null && userData !== undefined) {
            var roleId = userData.role;

            var navButtons = [];
            if (userData.isEnabled) {
                switch (roleId) {
                    case Roles.Admin:
                        AdminNavRoutes.forEach((link) => navButtons.push(link));
                        break;

                    case Roles.IddinkEmployee:
                        IddinkEmployeeRoutes.forEach((link) => navButtons.push(link));
                        break;

                    case Roles.IddinkSchoolManager:
                        SchoolNavRoutes.forEach((link) => navButtons.push(link));
                        break;

                    case Roles.SchoolManager:
                        SchoolNavRoutes.forEach((link) => navButtons.push(link));
                        break;

                    case Roles.Student:
                        StudentsNavRoutes.forEach((link) => navButtons.push(link));
                        break;

                    default:
                        LogOutRoute.forEach((link) => navButtons.push(link));
                }
            } else {
                LogOutRoute.forEach((link) => navButtons.push(link));
            }

            setNavBarButtons(navButtons);
        }
    };

    const toggleMenu = (menuItemId) => {
        if (openMenus.hasOwnProperty(menuItemId)) {
            setOpenMenus({ [menuItemId]: !openMenus[menuItemId] });
        } else {
            setOpenMenus({ [menuItemId]: true });
        }
    };

    const toggleMenuDropdown = (menuItemId) => {
        if (openMenus.hasOwnProperty(menuItemId)) {
            setOpenMenus({ ...openMenus, [menuItemId]: !openMenus[menuItemId] });
        } else {
            setOpenMenus({ ...openMenus, [menuItemId]: true });
        }
    };

    const openMenuIsOpen = () => {
        for (var key in openMenus) {
            if (openMenus.hasOwnProperty(key) && openMenus[key] === true) {
                return true;
            }
        }
        return false;
    };

    return (
        <div className="top-bar" ref={ref}>
            <div className="top-bar-logo">
                <img src="/InleverWhiteIcon.svg" alt="image" onClick={() => navigate(navBarButtons[0].link)} />
                <img
                    className="pt-1"
                    src="/InleverWhiteLogo.svg"
                    alt="image"
                    onClick={() => navigate(navBarButtons[0].link)}
                />
                <div className="language-selector-menu">
                    <LocalizationSwitcher changeLang={changeLang} />
                </div>
            </div>
            <div className="top-bar-menu" onClick={() => setMenuOpen(!menuOpen)}>
                {isMobile ? (
                    <span className="menu-icon">menu</span>
                ) : (
                    navBarButtons.map((x, i) => (
                        <MenuItem
                            key={i}
                            icon={x.icon}
                            alias={x.alias}
                            link={x.link}
                            children={x.children}
                            openMenus={openMenus}
                            toggleMenu={toggleMenu}
                            setMenuOpen={setMenuOpen}
                        />
                    ))
                )}
            </div>
            <div className={`menu-dropdown ${menuOpen && isMobile && `show`}`}>
                <ul className={"menu-dropdown-list"}>
                    {navBarButtons.map((x, i) => (
                        <MenuItemMobile
                            key={i}
                            icon={x.icon}
                            alias={x.alias}
                            link={x.link}
                            children={x.children}
                            openMenus={openMenus}
                            toggleMenu={toggleMenuDropdown}
                            setMenuOpen={setMenuOpen}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
}
